import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { mainColor } from '../../../styles/global';

export const CallToActionCardWrapper = styled.div`
    display:flex;
    justify-content: center;
    // align-items: center;
    flex-direction: column;
    padding:6rem 3rem;
    place-items: center;
    max-width:700px;
    width:100%;
    height:500px;
    border: 1px solid rgba(2, 1, 66, 0.2);
    box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    gap:2rem;
    img{
        height:100%;
        width:100%;
        object-fit: contain;
    }
    @media screen and (max-width: 768px) {
        height:350px;
        min-width:96%;
        gap:1rem;
        padding:4rem 3rem 2rem 3rem;

    }
`;

export const IconBox = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    background:#FDF2F4;
    padding:30px;
    border-radius:50%;
    @media screen and (max-width: 768px) {
    padding:20px;

    }

`;

export const CardTitle = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    font-family: 'Avenir';
    font-weight: 900;
    font-size: 40px;
    line-height: 55px;
    text-align: justify;
    letter-spacing: 0.01em;
    color:${mainColor};
    @media screen and (max-width: 768px) {
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 900;
        font-size: 27px;
        line-height: 33px;
        text-align: center;
        letter-spacing: 0.01em;
    }
`;
export const CardText = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-family: 'Avenir';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 25px;
    letter-spacing: 0.01em;
    color: #8D8D8D;
    margin-bottom:2%;
    @media screen and (max-width: 768px) {
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 19px;
        text-align: center;
        letter-spacing: 0.01em;
    }
`;
export const NavLink = styled(Link)`
    text-decoration: none;
    font-family: 'Avenir';
    font-style: normal;
    font-weight: 500;
    font-size: 32px;
    line-height: 50px;
    letter-spacing: 0.01em;
    color:${mainColor};
    display:flex;
    justify-content:center;
    align-items: center;
    @media screen and (max-width: 768px) {
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 500;
        font-size: 19px;
        line-height: 26px;
        letter-spacing: 0.01em;
    }
`;
